import { Component, OnInit, ViewChild } from "@angular/core";
import { WishesService } from "../wishes.service";
import { MatTableDataSource, MatSort } from "@angular/material";
import { Wish } from "../wish.model";

@Component({
  selector: "app-wish-list",
  templateUrl: "./wish-list.component.html",
  styleUrls: ["./wish-list.component.scss"]
})
export class WishListComponent implements OnInit {
  displayedColumns: string[] = ["name", "description", "category", "url"];
  dataSource: MatTableDataSource<Wish> = new MatTableDataSource();
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private wishesService: WishesService) {}

  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.wishesService.getJsonWishlist().subscribe(wishes => {
      this.dataSource.data = wishes;
    })
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
